import type { AxiosInstance } from 'axios'
import i18n from '../utils/i18n.utils'

export function attachLanguageInterceptor(client: AxiosInstance): void {
  client.interceptors.request.use((config) => {
    const currentLanguage = i18n.language

    if (currentLanguage) {
      config.headers['Accept-Language'] = currentLanguage
    }

    return config
  })
}
